/**
 * Created by qlong on 9/20/2016.
 */
import chroma from 'chroma-js';
import _ from 'lodash';

export default class Helper {
    // create series for chart
    static createSeries(index, chartData,color){
        // Create the data
        let data = []
        for (let i=0; i< chartData.yAxis.values[index].length; i++)
            data.push([chartData.xAxis.values[i], chartData.yAxis.values[index][i]])
        // Create the series
        var series = {
            id: index,
            name: chartData.yAxis.names[index],
            data: data,
            showInLegend: false,
            visible: true,
            color: color,
            lineWidth: 5,
            marker: {
                enabled: false
            },
        }

        return series
    }


// Get color set for manual selection
    static getInitialColorSet(max_series, offset){
        //Create the color set
        let colorSet = [];
        const hues = _.range(15, 375, (375-15)/(max_series))
        for (var index = offset; index < hues.length; index+=2) {
            colorSet.push(chroma.hcl(hues[index], 100, 65).hex())
        }

        // Reverse because we are going to pop the colors
        colorSet.reverse()
        return colorSet
    }


    // immutable delete object attributes
    static deleteObjectAttribute(state, action, attrName){
        let newState = Object.assign({}, state)
        newState[attrName] = Object.assign({}, state[attrName])
        delete newState[attrName][action.payload]
        return newState
    }

    //Line chart operation
    static updateLineChart({chart,index,color,action,redraw=false,chartData}){
        switch(action){
            case "add":
                chart.addSeries(this.createSeries(index,chartData,color),redraw)
                break
            case "changeColor":
                chart.get(index).update({color: color},redraw);
                break
            case "delete":
                chart.get(index).remove(redraw)
                break
            case "show":
                chart.get(index).setVisible(true, redraw)
                break
            case "hide":
                chart.get(index).setVisible(false, redraw)
                break
        }
    }

}





/** WEBPACK FOOTER **
 ** ./src/Helper.js
 **/